import React from "react";
import {
  CButton,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilX } from "@coreui/icons";

const getDisplayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

const RecordDetailOffcanvas = ({
  record,
  onHide,
  title,
  subtitle,
  fields = [],
  headerActions,
}) => (
  <>
    {record && (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "transparent",
          zIndex: 1040,
        }}
        onClick={onHide}
        aria-hidden="true"
      />
    )}

    <COffcanvas
      placement="end"
      visible={Boolean(record)}
      onHide={onHide}
      backdrop={false}
      scrollable
      scroll
      style={{ width: "560px", maxWidth: "95vw" }}
    >
      <COffcanvasHeader className="border-bottom">
        <COffcanvasTitle className="d-flex align-items-center me-auto">
          <div>
            <div className="fw-semibold">{title}</div>
            {subtitle && (
              <div className="text-medium-emphasis small">{subtitle}</div>
            )}
          </div>
        </COffcanvasTitle>
        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
          {headerActions}
          <CButton
            color="link"
            className="text-body p-0"
            onClick={onHide}
            title="Fechar"
          >
            <CIcon icon={cilX} />
          </CButton>
        </div>
      </COffcanvasHeader>
      <COffcanvasBody>
        {record && (
          <div className="d-flex flex-column gap-3">
            {fields.map((field) => (
              <div
                key={field.label}
                className="border rounded-3 p-3 bg-body-tertiary"
              >
                <div className="text-uppercase text-medium-emphasis small">
                  {field.label}
                </div>
                <div className={field.plain === false ? undefined : "fw-semibold"}>
                  {field.plain === false
                    ? field.value
                    : getDisplayValue(field.value)}
                </div>
              </div>
            ))}
          </div>
        )}
      </COffcanvasBody>
    </COffcanvas>
  </>
);

export default RecordDetailOffcanvas;
